const projectConfig = require('./pindex.js')

const config = {
  ...projectConfig
}

// /**
//  * 是否是对象
//  */
// function isObject(input) {
//   return Object.prototype.toString.call(input) === '[object Object]'
// }

// for (const key in config) {
//   if (isObject(defaultConfig[key]) && isObject(projectConfig[key])) {
//     config[key] = Object.assign({}, defaultConfig[key], projectConfig[key])
//   }
// }
module.exports = config
